import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";
axios.defaults.timeout = 10000;

export default store => {
  return {
    $store: store,
    list(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url:
            API_BASE +
            `/locations/${id}/porderscaware/?order_by=-creation_date`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    get(id, params = {}) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/porders/?order_code=${id}`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    report(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/porders/" + id + "/report/",
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    report_boxes(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          timeout: 30000,
          url: API_BASE + "/porders/" + id + "/boxes/?order_by=box__codebar",
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    sync(id, status) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: API_BASE + "/porders/" + id + "/",
          data: {
            sync: status
          }
        })
      )
        .then(response => {
          this.$store.commit("sync", response.data);
          this.$store.commit("loading", false);

          return response;
        })
        .catch(error => {
          throw error;

          // if (error.response === undefined) {
          //   dispatchError(this.$store, 'Error de conexión. Inténtelo más tarde')
          // } else {
          //   dispatchError(this.$store, error.response.data.message)
          //   throw error
          // }
        });
    },
    printers(params = {}) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/printers/",
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },

    print(id, printer) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + "/porders/" + id + "/printing/",
          data: {
            printer_id: printer
          }
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    printBoxes(id, printer) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + "/rboxes/" + id + "/printing/",
          data: {
            printer_id: printer
          }
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    getVerifications(params = {}) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/verifications/",
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    getRBVerifications(id, params = {}) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/rboxes/${id}/verifications/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    setVerification(data = {}) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: API_BASE + `/verifications/${data.id}/`,
          data: data
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    getVerificationReport(id, params = {}) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/verifications/${id}/report/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },

    getVerificationItems(id, params = {}) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/verifications/${id}/items/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    download(id) {
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "GET",
          url: API_BASE + `/porders/${id}/csv/`
        })
      )
        .then(blob => {
          var binaryData = [];
          binaryData.push(blob.data);
          var url = window.URL.createObjectURL(
            new Blob(binaryData, {
              type: "application/*"
            })
          );
          var a = document.createElement("a");
          a.href = url;
          a.download = "file.csv";
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove(); // afterwards we remove the element again
        })
        .catch(err => {
          throw err;
        });
    },
    addPurchaseOrder(params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + "/porders/",
          data: { ...params }
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    deleteOrder(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "DELETE",
          url: API_BASE + `/porders/${id}/`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
